/**
 * NoPermission — 메뉴 권한이 없는 화면에 진입했을 때의 공용 안내(라우터 진입 가드·기본 진입 경로).
 * 서버가 최종 차단하므로 이 화면은 UX 보조다.
 */
import { useTranslation } from "react-i18next";

export function NoPermission({ message }: { message?: string }) {
  const { t } = useTranslation();
  return (
    <div className="page">
      <div className="muted" style={{ textAlign: "center", padding: "60px 0" }}>
        {message ?? t("auth.unauthorized", "접근 권한이 없습니다")}
      </div>
    </div>
  );
}
